import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Show the example sentence with the target word blanked, pick the missing word. */
export function SentenceGap({ word, distractors, onAnswer }: ChallengeProps) {
  const choices = useChoices(word, distractors);
  const { picked, handle, teachOverlay } = usePickHandler(word, onAnswer);

  const re = new RegExp(`\\b${escapeRegex(word.english)}\\b`, "i");
  const blanked = word.sentence?.match(re)
    ? word.sentence.replace(re, "____")
    : `${word.sentence ?? ""} ____`;

  return (
    <>
      <ChallengeShell
        tag="Fill the gap"
        prompt={blanked}
        speakerText={word.sentence ?? word.english}
        speakerAudioUrl={word.sentenceAudioUrl ?? null}
      >
        <ChoiceGrid
          choices={choices}
          correctId={word.id}
          picked={picked}
          onPick={handle}
          render={(c) => <span className="choice-vi">{c.english}</span>}
        />
      </ChallengeShell>
      {teachOverlay}
    </>
  );
}

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
